export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9801.8e8010b1.jpg";